module.exports = __webpack_public_path__ + "img/rg-back.6b137230.png";